/*
 * @Description: 
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2022-03-23 17:16:57
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-03-23 17:18:11
 */
const sys = [
    {
        path: '/article/list/:id',
        name: 'articleList',
        component: () => import('../views/wxArticle/list.vue'),
        meta:{
            keepAlive:true
        }
    },
]
export default sys


// WEBPACK FOOTER //
// ./src/router/wx.js